<campus-card [showBadge]="!!badge" [disabled]="disabled">
  <campus-card-image data-cy="books-tile-logo"><img [src]="logoUrl" /></campus-card-image>
  @if (title) {
    <campus-card-title data-cy="books-tile-title">{{ title }}</campus-card-title>
  }
  @if (badge) {
    <campus-card-badge data-cy="books-tile-badge">
      @if (badge.icon) {
        <campus-icon [svgIcon]="badge.icon" class="shared-books-tile__badge-icon"></campus-icon>
      }
      <dcr-animated-kai
        #kai
        class="kai"
        [src]="'kai_state_machine.riv' | assetsPath: 'rive'"
        track-lookat
        autoplay
        react-to-click
      ></dcr-animated-kai>
      @if (badge.label) {
        <span class="ui-caption shared-books-tile__badge-label">{{ badge.label }}</span>
      }
    </campus-card-badge>
  }
  <campus-card-content>
    <div class="shared-books-tile__rows shared-books-tile--column">
      @if (headerIcon) {
        <div class="ui-demo-badge"
          ><campus-icon [svgIcon]="headerIcon.icon"></campus-icon> {{ headerIcon.label }}
        </div>
      }
      @if (rows.length) {
        <div>
          @for (row of rows; track trackByRowGuid($index, row)) {
            <div
              data-cy="books-tile-book"
              class="[ relative flex gap-xs items-center justify-between ][ p-b-2xs p-i-s ][ state-layer-group ]"
              #rowElement
              >
              <div
                data-cy="books-tile-name"
                class="[ grow ][ title-medium line-clamp-2 ]"
                [style.cursor]="row.actions?.length ? 'default' : 'pointer'"
                [class.shared-books-tile__book-name--centered]="!row.actions?.length"
                (click)="onRowClick(row)"
                >{{ row.label }}
                @if (row.icon) {
                  <div class="shared-books-tile__badge-container">
                    <div [class]="row.icon.className">
                      <campus-icon [svgIcon]="row.icon.icon"></campus-icon> {{ row.icon.label }}
                    </div>
                  </div>
                }
              </div>
              <div data-cy="books-tile-button-group" class="[ shrink-0 cluster cluster-space-3xs ]">
                <div>
                  @for (action of row.actions; track trackByRowGuid($index, action)) {
                    @if (action.icon.icon.startsWith('favorite')) {
                      <button
                        toggle-icon-button
                        class="favorite-toggle"
                        data-cy="shared-books-link"
                        (click)="action.handler(row.guid, data?.id)"
                        [icon]="action.icon.icon"
                        [selected]="action.icon.className === 'is-favorite'"
                  [ngClass]="
                    action.icon.className === 'is-favorite'
                      ? 'animate-jello-horizontal icon-primary'
                      : 'hover:icon-primary'
                  "
                        >
                      </button>
                    } @else {
                      <button
                        outline-icon-button
                        data-cy="books-tile-link"
                        (click)="action.handler(row.guid, data?.id)"
                        [icon]="action.icon.icon"
                        class="hover:icon-primary"
                        [ngClass]="action.icon.className"
                        >
                      </button>
                    }
                  }
                </div>
              </div>
              <campus-state-layer [for]="rowElement" class="bg-primary"></campus-state-layer>
            </div>
          }
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </campus-card-content>
</campus-card>

